import { EMBED } from '@/constants/routes';

/** True for `/embed` and any route below it. */
export function isEmbedPathname(pathname: string): boolean {
  return pathname === EMBED || pathname.startsWith(`${EMBED}/`);
}

/**
 * Resolve a string path against the active `urlBase` (embed prefix).
 * Absolute URLs and paths already carrying the base are returned untouched.
 */
export function resolvePathWithBase(path: string, urlBase: string): string {
  if (path.startsWith('http:') || path.startsWith('https:')) {
    return path;
  }
  if (urlBase && path.startsWith(urlBase)) {
    return path;
  }
  return `${urlBase}${path}`;
}
